<div class="p-3">


  <header class="fs-24 fw-600 ms-2 pt-2 hex-65-grey">Detail Search</header>
  <form class="form form-inline mb-4 ms-2" role="search" (submit)="search()">
    <div class="form-group col-md-4 col-sm-12 p-0 d-flex">
      <input [(ngModel)]="term" name="searchTerm" class="form-control rounded-0  " type="text" id="search_input"
        placeholder="Type and click on search" autocomplete="off" />
      <button type="submit" class="btn btn-primary btn-sm p-1 mx-2" id="search_btn">Search</button>
      <button class="btn btn-primary  " (click)="location.back()">Back</button>
    </div>

  </form>

  <div class="card card-default " *ngIf="emptyData">
    <div class="card-header">Search - "{{term?term:''}}"</div>
    <div class="card-body">
      <p class="text-center">No Result Found!</p>
    </div>
  </div>

  <div class="row m-0 mx-5 p-0 px-5">
    <div 
      *ngIf="(show && show.doctor) && !emptyData">
      <div class="card card-default p-2">
        <h3 class="m-0 fs-24 fw-600 hex-65-grey mb-2">Businesses</h3>
        <div class="p-2 row">
          <div class="col-md-12 mb-3" *ngFor="let doctor of results"
            [routerLink]="'/app/business/details/'+_shared.encodeId(doctor.doctor_id)">
            <div class="col-12 py-2 border rounded clickable-item px-2 ">
              <h3 class="my-1 text-green fs-24">
                {{doctor.doctor_name ? doctor.doctor_name : 'N/A'}}
              </h3>
              <div class="row">
                <div class="col-6 text-label">
                  <span class="text-muted">Email:</span>
                  <span [innerHTML]="(doctor.doctor_email || 'N/A')| highlight:searched_string"></span>
                </div>
                <div class="col-6 text-label"><span class="text-muted">Phone:</span>
                  {{doctor.doctor_mobile || 'N/A'}}</div>
                <div class="col-6 text-label">
                  <span class="text-muted">Business Name:</span>
                  <span [innerHTML]="(doctor.practice_name || 'N/A') | highlight:searched_string"></span>
                </div>
                <div class="col-6 text-label">
                  <span class="text-muted">Business Email:</span>
                  <span [innerHTML]="(doctor.practice_email || 'N/A') | highlight:searched_string"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div 
      *ngIf="(show && show.contract) && !emptyData">
      <div class="card card-default p-2">
        <h3 class="m-0 fs-24 fw-600 hex-65-grey mb-2">Contracts</h3>
        <div class="p-2 row">
          <div class="col-md-12 mb-3" *ngFor="let contract of results"
            [routerLink]="'/app/contracts/details/'+_shared.encodeId(contract.contract_id)" id="contract_details">
            <div class="col-12 py-2 border rounded clickable-item px-2 ">
              <h3 class="my-1 text-green fs-20">
                <span [innerHTML]="contract.contract_code | highlight:searched_string"
                  class="h3 text-bold fs-20 me-2 "></span>
                <span *ngIf="contract.pf_status<3" class="badge bg-primary float-right">Active</span>
                <span *ngIf="contract.pf_status==3" class="badge bg-warning float-right">Overdue</span>
                <span *ngIf="contract.pf_status==4" class="badge bg-success float-right">Completed</span>
                <span *ngIf="contract.pf_status==5" class="badge bg-danger float-right">Canceled</span>
              </h3>
              <div class="row">
                <div class="col-6 text-label"><span class="text-muted">Business Owner Name:</span>
                  {{contract.doctor_title}} <span
                    [innerHTML]="(contract.doctor_name || 'N/A') | highlight:searched_string:'capital'"></span>
                </div>
                <div class="col-6 text-label"><span class="text-muted">Business Owner Email:</span>
                  <span [innerHTML]="(contract.doctor_email || 'N/A') | highlight:searched_string"></span>
                </div>
                <div class="col-6 text-label"><span class="text-muted">Customer Name:</span>
                  <span [innerHTML]="(contract.patient_name || 'N/A') | highlight:searched_string:'capital'"></span>
                </div>
                <div class="col-6 text-label"><span class="text-muted">Customer Email:</span>
                  <span [innerHTML]="(contract.patient_email || 'N/A')| highlight:searched_string"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div 
      *ngIf="(show && show.partner) && !emptyData">
      <div class="card card-default p-2">
        <h3 class="m-0 fs-24 fw-600 hex-65-grey mb-2">Partners</h3>
        <div class="p-2 row">
          <div class="col-md-12 mb-3" *ngFor="let partner of results"
            (click)="viewPartner(partner.partner_id)">
            <div class="col-12 py-2 border rounded clickable-item px-2 ">
              <h3 class="my-1 text-green fs-24">{{partner.title}}
                <span class="h3 text-bold fs-24"
                  [innerHTML]="partner.partner_name | highlight:searched_string:'capital'"></span>
              </h3>
              <div class="row">
                <div class="col-6 text-label"><span class="text-muted">Email:</span>
                  <span [innerHTML]="partner.partner_email | highlight:searched_string"></span>
                </div>
                <div class="col-6 text-label"><span class="text-muted">Phone:</span>
                  {{partner.partner_mobile}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div 
      *ngIf="(show && show.patient) && !emptyData">
      <div class="card card-default p-2">
        <h3 class="m-0 fs-24 fw-600 hex-65-grey mb-2">Customers</h3>
        <div class="p-2 row">
          <div class="col-md-12 mb-3" *ngFor="let patient of results"
            [routerLink]="'/app/customers/profile/'+_shared.encodeId(patient.patient_id)">
            <div class="col-12 py-2 border rounded clickable-item px-2 ">
              <h3 class="my-1 text-green fs-20">{{patient.patient_title}}
                <span class="h3 text-bold fs-20"
                  [innerHTML]="(patient.patient_name || 'N/A') | highlight:searched_string:'capital'"></span>
              </h3>
              <div class="row">
                <div class="col-6 text-label"><span class="text-muted">Email:</span>
                  <span [innerHTML]="(patient.patient_email || 'N/A') | highlight:searched_string"></span>
                </div>
                <div class="col-6 text-label"><span class="text-muted">Phone:</span>
                  {{patient.patient_mobile || 'N/A'}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div 
      *ngIf="(show && show.payments) && !emptyData">
      <div class="card card-default p-2">
        <h3 class="m-0 fs-24 fw-600 hex-65-grey mb-2">Payments Processed</h3>
        <div class="p-2 row">
          <div class="col-md-12 mb-3" *ngFor="let payment of results"
            [routerLink]="'/app/payment-processing/'+payment.id">
            <div class="col-12 py-2 border rounded clickable-item px-2 ">
              <h3 class="my-1 text-green fs-24">
                <span class="h3 text-bold fs-24"
                  [innerHTML]="payment.patient_name | highlight:searched_string:'capital'"></span>
                <span *ngIf="payment.status==1" class="badge bg-warning float-right">Pending</span>
                <span *ngIf="payment.status==2" class="badge bg-success float-right">Success</span>
                <span *ngIf="payment.status==3" class="badge bg-danger float-right">Failed</span>
                <span *ngIf="payment.status==4" class="badge bg-info float-right">Refunded</span>
                <span *ngIf="payment.status==5" class="badge bg-danger float-right">Declined</span>
              </h3>
              <div class="row">
                <div class="col-6 text-label">
                  <span class="text-muted">Email:</span>
                  <span [innerHTML]="payment.patient_email | highlight:searched_string"></span>
                </div>
                <div class="col-6 text-label">
                  <span class="text-muted">Phone:</span>
                  {{payment.patient_mobile ? (payment.patient_mobile): 'N/A'}}
                </div>
                <div class="col-12 text-label">
                  <span class="text-muted">Payment ID:</span>
                  <span *ngIf="payment.payment_process_code"
                    [innerHTML]="payment.payment_process_code | highlight:searched_string"></span>
                  <span *ngIf="!payment.payment_process_code">N/A</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div  *ngIf="(show && show.ar) && !emptyData">
      <ng-container *ngIf="results as proposal_ar">
        <ng-container
          *ngTemplateOutlet="proposals_listing; context: {data: {list: proposal_ar, heading: 'Debt Recovery', link: '/app/debt-recovery/details/', encode: true}}"></ng-container>
      </ng-container>
    </div>
    <div 
      *ngIf="(show && show.proposal) && !emptyData">
      <ng-container *ngIf="results as proposal">
        <ng-container
          *ngTemplateOutlet="proposals_listing; context: {data: {list: proposal, heading: 'Proposal Request', link: '/app/debt-recovery/details/', encode: true}}"></ng-container>
      </ng-container>
    </div>

    <div 
      *ngIf="(show && show.settled_accounts) && !emptyData">
      <ng-container *ngIf="results as proposal">
        <ng-container
          *ngTemplateOutlet="proposals_listing; context: {data: {list: proposal, heading: 'Paid In Full Accounts', link: '/app/debt-recovery/payment-details/', encode: true}}"></ng-container>
      </ng-container>
    </div>

    <div 
      *ngIf="(show && show.pa_leads) && !emptyData">
      <div class="card card-default p-2">
        <h3 class="m-0 fs-24 fw-600 hex-65-grey mb-2">Pre-approval Leads</h3>
        <div class="p-2 row">
          <div class="col-md-12 mb-3" *ngFor="let lead of results"
            [routerLink]="'/app/patients/customers-leads/details/'+lead.application_id">
            <div class="col-12 py-2 border rounded clickable-item px-2 ">
              <h3 class="my-1 text-green fs-24">
                <span [innerHTML]="lead.application_id | highlight:searched_string" class="h3 text-bold fs-24"></span>
              </h3>
              <div class="row">
                <div class="col-6 text-label"><span class="text-muted">Business Owner Name:</span>
                  <span
                    [innerHTML]="(lead.doctor_first_name + lead.doctor_last_name) | highlight:searched_string"></span>
                </div>
                <div class="col-6 text-label"><span class="text-muted">Business Owner Email:</span>
                  <span [innerHTML]="lead.doctor_email | highlight:searched_string"></span>
                </div>
                <div class="col-6 text-label"><span class="text-muted">Customer Name:</span>
                  <span [innerHTML]="lead.full_cust_name | highlight:searched_string"></span>
                </div>
                <div class="col-6 text-label"><span class="text-muted">Customer Email:</span>
                  <span [innerHTML]="lead.customer_email | highlight:searched_string"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div 
      *ngIf="(show && show.training) && !emptyData">
      <div class="card card-default p-2">
        <h3 class="m-0 fs-24 fw-600 hex-65-grey mb-2">Trainings</h3>
        <div class="p-2 row">
          <div class="col-md-12 mb-3" *ngFor="let trianing of results"
            [routerLink]="'/app/training/details/'+_shared.encodeId(trianing.training_event_time_slot_id)">
            <div class="col-12 py-2 border rounded clickable-item px-2 ">
              <h3 class="my-1 text-green fs-20">
                <span [innerHTML]="trianing.training_doctor_partner_name | highlight:searched_string:'capital'" 
                  class="h3 text-bold fs-20 me-2"></span>
                <span class=" rounded text-white h-25 float-right p-0 ps-2 pe-2 mt-2 ms-2 text-center"
                  [ngStyle]="{'background-color':trianing?.training_status_color_code || ''}">{{trianing?.training_status_name || ''}}</span>
              </h3>
              <div class="row">
                <div class="col-6 text-label">
                  <span class="text-muted">Email: </span>
                  <span [innerHTML]="(trianing.training_doctor_partner_email || 'N/A') | highlight:searched_string"></span>
                </div>
                <div class="col-6 text-label"><span class="text-muted">Phone: </span>
                  {{trianing.training_doctor_partner_phone? trianing.training_doctor_partner_phone : 'N/A'}}
                </div>
                <!-- <div class="col-6 text-label">
                  <span class="text-muted">Type of Training: </span>
                  <span [innerHTML]="trianing.type_name | highlight:searched_string"></span>
                </div> -->
                <div class="col-6 text-label">
                  <span class="text-muted">Business Name: </span>
                  <span [innerHTML]="(trianing.training_practice_name || 'N/A') | highlight:searched_string"></span>
                </div>
                <div class="col-6 text-label">
                  <span class="text-muted">Business Email: </span>
                  <span [innerHTML]="(trianing.practice_email || 'N/A') | highlight:searched_string"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div 
      *ngIf="(show && show.assignments) && !emptyData">
        <div class="card card-default p-2">
          <h3 class="m-0 fs-24 fw-600 hex-65-grey mb-2">Followup Assignments</h3>
          <div class="p-2 row">
            <div class="col-md-12 mb-3" *ngFor="let assignment of results"
              [routerLink]="'/app/assignments/my-assignments/'+_shared.encodeId(assignment.req_id)">
              <div class="col-12 py-2 border rounded clickable-item px-2 ">
                <span class="d-flex">
                <h3 class="my-1 text-green fs-24">
                  {{(assignment.account_id || assignment.patient_name) ? (assignment.patient_name || 'N/A') : assignment.doctor_name ? assignment.doctor_name : assignment.wp_name ? assignment.wp_name : assignment.name ? assignment.name : 'N/A'}}
                </h3>
                <span *ngIf="assignment.status == 0"
                  class="badge bg-warning"style="
    margin-bottom: 10px;
    margin-top: 10px;
    font-size: 1.0em;
">Pending</span>
                <span *ngIf="assignment.status == 1"
                  class="badge bg-dark"style="
    margin-bottom: 10px;
    margin-top: 10px;
    font-size: 1.0em;
">Closed</span>
                <span *ngIf="assignment.status == 2"
                  class="badge bg-primary"style="
    margin-bottom: 10px;
    margin-top: 10px;
    font-size: 1.0em;
">Re-Opened</span>
                <span *ngIf="assignment.status == 3"
                  class="badge bg-info"style="
    margin-bottom: 10px;
    margin-top: 10px;
    font-size: 1.0em;
">Follow up</span>
                </span>
                <div class="row" *ngIf="assignment.account_id || assignment.patient_name; else businessInfo">
                  <div class="col-6 text-label">
                    <span class="text-muted">Account ID: </span>
                    <span [innerHTML]="(assignment.account_id || 'N.A') | highlight:searched_string"></span>
                  </div>
                  <div class="col-6 text-label"><span class="text-muted">Phone: </span>
                    {{assignment.patient_mobile || 'N.A'}}</div>
                  <div class="col-6 text-label">
                    <span class="text-muted">Email: </span>
                    <span [innerHTML]="(assignment.patient_email || 'N.A') | highlight:searched_string"></span>
                  </div>
                </div>
                <ng-template #businessInfo>
                <div class="row">
                  <div class="col-6 text-label">
                    <span class="text-muted">Email: </span>
                    <span [innerHTML]="(assignment.doctor_email || assignment.patient_email || assignment.wp_email || assignment.email || 'N.A')| highlight:searched_string"></span>
                  </div>
                  <div class="col-6 text-label"><span class="text-muted">Phone: </span>
                    {{assignment.doctor_mobile || assignment.patient_mobile || assignment.wp_phone || assignment.mobile || 'N.A'}}</div>
                  <div class="col-6 text-label">
                    <span class="text-muted">Business Name: </span>
                    <span [innerHTML]="(assignment.practice_name || 'N.A') | highlight:searched_string"></span>
                  </div>
                  <div class="col-6 text-label">
                    <span class="text-muted">Business Email: </span>
                    <span [innerHTML]="(assignment.practice_email || 'N.A') | highlight:searched_string"></span>
                  </div>
                </div>
                </ng-template>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div 
      *ngIf="(show && show.callback_assignments) && !emptyData">
        <div class="card card-default p-2">
          <h3 class="m-0 fs-24 fw-600 hex-65-grey mb-2">Callback Assignments</h3>
          <div class="p-2 row">
            <div class="col-md-12 mb-3" *ngFor="let assignment of results"
              [routerLink]="'/app/assignments/my-assignments/'+_shared.encodeId(assignment.req_id)">
              <div class="col-12 py-2 border rounded clickable-item px-2 ">
                <span class="d-flex">
                <h3 class="my-1 text-green fs-24">
                  {{assignment.doctor_name ? assignment.doctor_name : assignment.name ? assignment.name : assignment.patient_name ? assignment.patient_name : 'N/A'}}
                </h3>
                <span *ngIf="assignment.status == 0"
                  class="badge bg-warning"style="
    margin-bottom: 10px;
    margin-top: 10px;
    font-size: 1.0em;
">Pending</span>
                <span *ngIf="assignment.status == 1"
                  class="badge bg-dark"style="
    margin-bottom: 10px;
    margin-top: 10px;
    font-size: 1.0em;
">Closed</span>
                <span *ngIf="assignment.status == 2"
                  class="badge bg-primary"style="
    margin-bottom: 10px;
    margin-top: 10px;
    font-size: 1.0em;
">Re-Opened</span>
                <span *ngIf="assignment.status == 3"
                  class="badge bg-info"style="
    margin-bottom: 10px;
    margin-top: 10px;
    font-size: 1.0em;
">Follow up</span>
                </span>
                <div class="row">
                  <div class="col-6 text-label">
                    <span class="text-muted">Email: </span>
                    <span [innerHTML]="(assignment.doctor_email || assignment.email || assignment.patient_email || 'N/A')| highlight:searched_string"></span>
                  </div>
                  <div class="col-6 text-label"><span class="text-muted">Phone: </span>
                    {{assignment.doctor_mobile || assignment.mobile || assignment.patient_mobile || 'N/A'}}</div>
                  <div class="col-6 text-label">
                    <span class="text-muted">Request: </span>
                    <span [innerHTML]="(assignment.action_value || 'N/A') | highlight:searched_string"></span>
                  </div>
                  <!-- <div class="col-6 text-label">
                    <span class="text-muted">Business Email:</span>
                    <span [innerHTML]="(assignment.practice_email || 'N/A') | highlight:searched_string"></span>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  </div>

  <ng-template #proposals_listing let-data="data">
    <div class="card card-default p-2">
      <h3>{{data.heading}}</h3>
      <div class="p-2 row">
        <div class="col-md-12 mb-3" *ngFor="let payment of results" [routerLink]="data.link + (data.encode ? _shared.encodeId(payment.split_req_id) : payment.split_req_id)" [queryParams]="{ is_deleted: payment.is_deleted }">
          <div class="col-12 py-2 border rounded clickable-item px-2 ">
            <h3 class="my-1 text-green fs-20">
              <span class="h3 text-bold fs-20"
                [innerHTML]="payment.patient_name | highlight:searched_string:'capital'"></span>
              <!-- <span *ngIf="payment.status==1" class="badge bg-warning float-right">Pending</span>
              <span *ngIf="payment.status==2" class="badge bg-success float-right">Success</span>
              <span *ngIf="payment.status==3" class="badge bg-danger float-right">Failed</span>
              <span *ngIf="payment.status==4" class="badge bg-info float-right">Refunded</span>
              <span *ngIf="payment.status==5" class="badge bg-danger float-right">Declined</span> -->

              <span *ngIf="payment.amount_deducted> 0 && payment.stripe_status != 1" class="badge bg-success float-right fw-600 ms-1">Settled-Paid In Full</span>
              <span *ngIf="payment.amount_deducted> 0 && payment.stripe_status == 1" class="badge bg-primary float-right fw-600 ms-1">Refunded</span>
              <span *ngIf="payment.webhook_status == 0" class="badge bg-warning float-right fw-600 ms-1">Initiated</span>
              <span *ngIf="payment.webhook_status == 2 " class="badge bg-danger float-right fw-600 ms-1">Failed</span>
            </h3>
            <div class="row">
              <div class="col-6 text-label"><span class="text-muted">Business Owner Name:</span>
                <span [innerHTML]="(payment.doctor_name || 'N/A') | highlight:searched_string"></span>
              </div>
              <div class="col-6 text-label"><span class="text-muted">Business Owner Email:</span>
                <span [innerHTML]="(payment.doctor_email || 'N/A') | highlight:searched_string"></span>
              </div>
              <div class="col-6 text-label"><span class="text-muted">Customer Email:</span>
                {{payment.patient_email ? (payment.patient_email): 'N/A'}}</div>
              <div class="col-6 text-label"><span class="text-muted">Customer Phone:</span>
                {{payment.patient_mobile ? (payment.patient_mobile): 'N/A'}}</div>
                <div class="col-6 text-label"><span class="text-muted">Account ID:</span>
                {{payment.contract_code ? payment.contract_code :  payment.contract_patient_token.toUpperCase() }}
              </div>
              <!-- <div class="col-12 text-label">
              <span class="text-muted">Payment ID:</span>
              <span *ngIf="payment.payment_process_code"
                [innerHTML]="payment.payment_process_code | highlight:searched_string"></span>
              <span *ngIf="!payment.payment_process_code">N/A</span>
            </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>

  <div class="d-flex m-0 pt-2 align-items-center inserted justify-content-between " *ngIf="!emptyData">
    <div >
      <p class="fs-14 fw-500 m-0">
        Showing {{(1+(pageNumber - 1) * 10)}} to {{(results?.length + (pageNumber - 1) *
        10)}} of {{totalRows || 'all'}}
      </p>
    </div>
    <div >
      <pagination class="pagination-sm float-md-end" [totalItems]="totalRows" [maxSize]="5" [boundaryLinks]="true"
        [rotate]="false" (pageChanged)="pageChanged($event)" [(ngModel)]="pageNumber">
      </pagination>
    </div>
  </div>
</div>